import { Button, Form, Input } from 'antd';
import React, { useEffect } from 'react';
import { useCountries } from './CountryStore';
import { useForm } from 'antd/es/form/Form';

function Edit(props) {
    let { updateCountry, ed } = useCountries()
    let [form] = useForm();
    useEffect(() => {
        form.setFieldsValue(ed)
    }, [ed])
    return (
        <Form form={form} layout="vertical" onFinish={updateCountry} encType="multipart/form-data">
            <Form.Item name={'id'} hidden>
                <Input />
            </Form.Item>
            <Form.Item label="O'zbekcha nomi" name="nameuz" rules={[{ required: true, message: 'Please input your name!' }]}>
                <Input />
            </Form.Item>
            <Form.Item label="Ruscha nomi" name="nameru" rules={[{ required: true, message: 'Please input your description!' }]}>
                <Input />
            </Form.Item>
            <Form.Item>
                <Button type="primary" htmlType="submit">O'zgartirish</Button>
            </Form.Item>
        </Form>
    );
}

export default Edit;